/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React, {  useState,
  useContext,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  InputAdornment,
  IconButton,
  Divider,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import locale from 'date-fns/locale/pt-BR';
import DateFnsUtils from '@date-io/date-fns';
import Select from 'react-select';
import api from '../../../service/axios/api';
import Loading from '../../../components/loading/Loading';
import FlashContext from '../../../components/contexts/FlashContext';

const selectStyles = {
  control: provided => ({
    ...provided,
    height: 60,
    minHeight: 60,
  }),
  menu: provided => ({
    ...provided,
    zIndex: 9999,
  }),
  menuPortal: base => ({
    ...base,
    zIndex: 9999,
  }),
};

export default function EditCostCenter({
  openEdit,
  setOpenEdit,
  loadingEdit,
  handleEdit,
  costCenter,
  setCostCenter,
}) {
  const { t } = useTranslation();
  const { notifyError } = useContext(FlashContext);

  const [costCenterList, setCostCenterList] = useState([]);

  const getCostCenters = async () => {
    try {
      const { data } = await api.costCenter.getAllSelect();
      const list = [
        {
          value: 0,
          label: t('receivables.createDialog.fields.noCostCenter'),
        },
      ];
      data.retorno.forEach(item => {
        list.push({
          value: item.id,
          label: item.name,
        });
      });
      setCostCenterList(list);
    } catch (error) {
      notifyError(error.message);
      console.log(error);
    }
  };

  const handleClose = () => {
    setCostCenter(0);
  };

  useEffect(() => {
    getCostCenters();
  }, []);

  return (
    <Dialog
      onClose={() => setOpenEdit(false)}
      open={openEdit}
      fullWidth
      maxWidth="sm"
    >
      <Loading
        open={loadingEdit}
        msg={t('receivables.updateCostCenterDialog.loading')}
      />
      <DialogTitle id="simple-dialog-title">
        {t('receivables.updateCostCenterDialog.title')}
      </DialogTitle>
      <DialogContent>
        <Grid
          container
          spacing={3}
          style={{
            justifyContent: 'center',
          }}
        >
          <Grid item sm={12} xs={12}>
            <Select
              value={costCenterList.find(opt => opt.value === costCenter)}
              placeholder={t('receivables.createDialog.fields.costCenter')}
              onChange={e => setCostCenter(e.value)}
              options={costCenterList}
              styles={selectStyles}
              maxMenuHeight={200}
              menuPortalTarget={document.body}
              captureMenuScroll
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          style={{ height: 40 }}
          onClick={handleClose}
          variant="text"
          color="primary"
        >
          {t('receivables.createDialog.buttons.cancel')}
        </Button>
        <Button
          style={{ height: 40 }}
          onClick={handleEdit}
          disabled={loadingEdit}
          variant="contained"
          color="primary"
        >
          {t('receivables.updateCostCenterDialog.buttons.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
